import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@apollo/client';
import { GET_CART } from '@/graphql/queries';
import useZipCode from 'global-state/zipCode/useZipCode';
const useCartAndToken = () => {
  const $ = _c(6);
  const zipCode = useZipCode();
  let t0;
  if ($[0] !== zipCode) {
    t0 = {
      fetchPolicy: "cache-and-network",
      variables: {
        zipCode
      }
    };
    $[0] = zipCode;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    data,
    refetch
  } = useQuery(GET_CART, t0);
  const cart = data?.getCart?.cart;
  const token = data?.getCart?.cart_token;
  let t1;
  if ($[2] !== cart || $[3] !== refetch || $[4] !== token) {
    t1 = {
      cart,
      refetch,
      token
    };
    $[2] = cart;
    $[3] = refetch;
    $[4] = token;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
};
export default useCartAndToken;